<template lang="pug">
#page_content.nominee.page
	Banner(v-bind:item='item_banner', classes='half')
	.container
		.row
			.col-12
				div(v-if='$i18n.locale === "tw"')
					h2 2022 TICFF 國際競賽入圍與得獎名單
					p 本屆台灣國際兒童影展有來自 72 國共計 721 部作品報名參賽，選出 26 部入圍作品。
				div(v-else)
					h2 Nominees of Competition Categories at 2022 TICFF
					p This year’s TICFF received 721 submissions from 72 countries, with 26 films and programs selected for final nominations.

			template(v-for='block in blocks')
				TitleStar
					template(v-slot:title) {{ $t(block) }}
				.col-md-4(
					v-for='(item, index) in items.filter(item => item.award_type === $t(block)).sort((a, b) => Number(a.id) - Number(b.id))',
					v-on:click='openPopup(item)'
				)
					CardVertical(
						v-bind:item='item',
						v-bind:classes='`nominee external_link ${item.honor ? "trophy" : ""}`'
					)

	#popup.modal.fade(
		tabindex='-1',
		aria-labelledby='popupLabel',
		aria-hidden='true'
	)
		.modal-dialog.modal-dialog-centered
			.modal-content
				.modal_bg(
					v-bind:style='{ backgroundImage: `url(${item_popup.image})` }'
				)
				.modal-header
					button.btn-close.btn-close-white(
						type='button',
						data-bs-dismiss='modal',
						aria-label='Close'
					)
				.modal-body
					.row
						.col-md-6
							.text
								.title_wrapper
									h3.type {{ item_popup.award_type }}
									.title {{ item_popup.title }}
									h5.title_en {{ item_popup.title_en }}
								p.desc {{ item_popup.desc }}
								template(v-if='item_popup.award && item_popup.award.split(",").length')
									hr
									.award_list
										h4.award(v-for='award in item_popup.award.split(",")') {{ award }}
						.col-md-6
							.ratio.ratio-16x9
								#popup_carousel.carousel.slide(data-bs-ride='carousel')
									.carousel-inner
										.carousel-item(
											v-for='(photo, index) in item_popup.photo',
											v-bind:class='{ active: index === 0 }'
										)
											img.d-block(
												v-bind:src='require(`@/assets/images/film_photo/nominee/${item_popup.id}/${photo}`)'
											)
									button.carousel-control-prev(
										type='button',
										data-bs-target='#popup_carousel',
										data-bs-slide='prev'
									)
										span.carousel-control-prev-icon(aria-hidden='true')
										span.visually-hidden Previous
									button.carousel-control-next(
										type='button',
										data-bs-target='#popup_carousel',
										data-bs-slide='next'
									)
										span.carousel-control-next-icon(aria-hidden='true')
										span.visually-hidden Next
</template>
<script>
import { Carousel, Modal } from 'bootstrap';
// import NomineeData from '@/assets/nominee.yaml';
import Banner from '@/components/Banner.vue';
import CardVertical from '@/components/CardVertical.vue';
import TitleStar from '@/components/TitleStar.vue';

export default {
	data() {
		return {
			blocks: [
				'nominee_dramatic_short',
				'nominee_dramatic_feature',
				'nominee_animated_short',
				'nominee_animated_fature',
				'nominee_tv_web_program',
				'nominee_documentary',
			],
			item_banner: {
				media: 'assets/images/banner_2.jpg',
				title: this.$t('nav_competition_nominee'),
			},
			items: [],
			popup: null,
			carousel: null,
			item_popup:
				require(`@/assets/data/nominee_${this.$i18n.locale}.yaml`)[0],
		};
	},
	methods: {
		refresh: function () {
			this.items =
				require(`@/assets/data/nominee_${this.$i18n.locale}.yaml`).map(
					item => {
						return {
							...item,
							image: require(`@/assets/images/film_photo/nominee/${item.id}/${item.image}`),
							title: item.title_tw,
							brief: `${item.stuff} | ${item.country}`,
						};
					}
				);
		},
		openPopup: function (item) {
			this.popup.show();
			this.item_popup = item;
		},
	},
	watch: {
		'$i18n.locale'() {
			this.item_banner.title = this.$t('nav_competition_nominee');
			this.refresh();
		},
	},
	created() {
		this.refresh();
	},
	mounted() {
		this.popup = new Modal(document.getElementById('popup'));
		this.carousel = new Carousel(document.getElementById('popup_carousel'));
		document
			.getElementById('popup')
			.addEventListener('hidden.bs.modal', () => {
				this.carousel.to(0);
			});
	},
	components: {
		Banner,
		CardVertical,
		TitleStar,
	},
};
</script>

<style lang="stylus">
#page_content.nominee
	line-height: 1.8
	.title_star
		margin-top: 50px
	.modal
		color: black
		.type
			line-height: 36px
			margin-bottom: 10px
		.title
			font-size: $fs-2
			font-weight: 500
			line-height: 36px
			margin-bottom: 2px
		.title_en
			margin-bottom: 0
		.desc
			font-weight: 500
			line-height: 1.8
			margin-top: 4rem
			text-align: justify
		.award_list
			margin-top: 1rem
			.award
				text-align: left
				margin-bottom: 0.8rem
		.carousel-inner
			height: 100%
			border-radius: 15px
		.carousel-item
			height: 100%
			img
				width: 100%
				height: 100%
				object-fit: cover
				object-position: center center
	.modal-dialog
		position: relative
	.modal_bg
		position: absolute
		width: 100%
		height: 100%
		background-size: cover
		background-position: center center
		opacity: 1
		border-radius: 24px
		filter: blur(3px) brightness(0.8)
		&:after
			content: ''
			position: absolute
			width: 100%
			height: 100%
			border-radius: 24px
			background: linear-gradient(180deg, rgba(66,115,193,0.4) 59%, rgba(30,59,109,1) 93%);
	.modal-content
		color: white
		background-color: transparent
		border-radius: 15px
		overflow: hidden
	.modal-header
		justify-content: flex-start
		border-bottom: 0
		.btn-close
			margin: -0.5rem
	.modal-body
		padding: 4rem

	// Replace default bootstrap behavior
	@media screen and (min-width: 576px)
		.modal-dialog
			width: 80vw
			max-width: 1200px
	@media screen and (max-width: $screen-sm-max)
		.modal
			.text
				margin-bottom: 2rem
			.desc
				margin-top: 2rem
			.modal-body
				padding: 2rem
</style>
